import styled from "styled-components";
const SearchPageDisplay = styled.div`
	// my css here
`;	export default SearchPageDisplay;
